import { render } from "./PieDePagina.vue?vue&type=template&id=4ef56e66"
import script from "./PieDePagina.vue?vue&type=script&lang=js"
export * from "./PieDePagina.vue?vue&type=script&lang=js"

import "./PieDePagina.vue?vue&type=style&index=0&id=4ef56e66&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__